import { Modal, Form } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import dayjs from 'dayjs'
import { useState, useEffect } from 'react'

import bufferToFileDownload from '@utils/download'

import ExpenditureAPI from '@apis/branch/expenditure'

import LocalDatePicker from '@components/atoms/LocalDatePicker'
import Loading from '@components/molecules/Loading'

type Props = {
  hqId: number
  branchId: number
  visible: boolean
  onClose: () => void
  onDone: () => void
}

export default function ExpenditureExportModal({ hqId, branchId, visible, onClose, onDone }: Props): JSX.Element {
  const [form] = useForm<{ date: [string, string] }>()
  const [loading, setLoading] = useState(false)

  const onOk = async () => {
    try {
      setLoading(true)
      const values = await form.validateFields()

      const { data } = await ExpenditureAPI.exportExpenditure({ hqId, branchId }, values)

      bufferToFileDownload('지출.xls', Buffer.from(data))

      setLoading(false)
      onDone()
      onClose()
    } catch (err) {
      setLoading(false)
    }
  }

  const reset = () => {
    form.resetFields()
  }

  useEffect(() => {
    if (visible) {
      reset()
    }
  }, [visible])

  const initialValues = {
    date: [dayjs().startOf('month').format('YYYY-MM-DD'), dayjs().endOf('month').format('YYYY-MM-DD')],
  }

  return (
    <Modal title="내보내기" okText="내보내기" onOk={onOk} confirmLoading={loading} visible={visible} onCancel={onClose}>
      <Loading loading={loading}>
        <Form form={form} layout="vertical" initialValues={initialValues}>
          <Form.Item
            name="date"
            label="기간"
            getValueFromEvent={(_, s) => s}
            getValueProps={([f, t]) => ({ value: [dayjs(f), dayjs(t)] })}
            required
          >
            <LocalDatePicker.RangePicker />
          </Form.Item>
        </Form>
      </Loading>
    </Modal>
  )
}
